import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from "../../features/userSlice";
//import Select, { components } from 'react-select';
import Select from 'react-select';  // ✅
import axios from 'axios';
import AttendanceCard from "../../components/AttendanceCard";
import styles from './ApproveDailyAttendance.module.css';

/*
const CustomOption = (props) => {
  const { innerRef, innerProps, isSelected, data } = props;
  return (
    <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
      <input type="checkbox" checked={isSelected} onChange={() => null} />
      <label style={{ marginLeft: 8 }}>{data.label}</label>
    </div>
  );
};
*/

const ApproveDailyAttendance = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const token = user?.token;
  const emp_id = user?.emp_id;

  const yesterdaySelectedEmployees = ['E001', 'E002', 'E003'];
  const [selectedDate, setSelectedDate] = useState("");
  const [contractorList, setContractorList] = useState([]);
  const [selectedContractor, setSelectedContractor] = useState([]);
  const [buList, setBu] = useState([]);
  const [selectedBU, setSelectedBU] = useState([]);
  const [entityList, setEntity] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState([]);
  const [deptList, setDepartment] = useState([]);
  const [selectedDept, setSelectedDepartment] = useState([]);

  const [empType, setEmpType] = useState([]);
  const [selectedEmpType, setSelectedEmpType] = useState(null);  // ✅ Correct

  const [attendanceData, setAttendanceData] = useState([]);
  const [selectedForApproval, setSelectedForApproval] = useState([]);
  const [isApprovedAlready, setIsApprovedAlready] = useState(false);
  const [isPartiallyApproved, setIsPartiallyApproved] = useState(false);
  const [filterOption, setFilterOption] = useState('DEPT'); 
  const [sortOption, setSortOption] = useState('ALPHABETICAL');
  const [yesterdayData, setYesterdayData] = useState([]);

  const [presentCount, setPresentCount] = useState(0);
  const [presentPxCount, setPresentPxCount] = useState(0);
  const [presentHdpCount, setPresentHdpCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [totalOtHours, setTotalOtHours] = useState("0.00");

  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const floatRef = useRef(null);

  const scrollToTop = () => topRef.current?.scrollIntoView({ behavior: 'smooth' });
  const scrollToBottom = () => bottomRef.current?.scrollIntoView({ behavior: 'smooth' });

  const fetchContractorData = async () => {
    const res = await axios.get('/api/contractor/getAllContractors');
    const data = res.data || [];
    const formatted = data.map(c => ({
      value: c.Contractor_ID,
      label: c.Contractor_Name
    }));
  
    setContractorList(formatted);
  };

  const fetchBUData = async () => {
    const res = await axios.post('/api/entity/getAssignedBU', { emp_id });
    const data = res.data || [];
    const formatted = data.map(c => ({
      value: c.bu_code,
      label: c.bu_name
    }));
    
    setBu(formatted);
  };

  const fetchEntityData = async () => {
    const res = await axios.post('/api/entity/getAssignedEntity', { emp_id });
    const data = res.data || [];
    const formatted = data.map(c => ({
      value: c.entity_code,
      label: c.entity_name
    }));
  
    setEntity(formatted);
  };

  const fetchDeptData = async () => {
    const res = await axios.post('/api/entity/getAssignedDept', { emp_id });
    const data = res.data || [];
    const formatted = data.map(c => ({
      value: c.dept_code,
      label: c.dept_name
    }));
  
    setDepartment(formatted);
  };

  const fetchEmpType = async () => {
    const res = await axios.get('/api/employee/getEmpType');
    const data = res.data || [];
    console.log("STage---0:", data);
    const formatted = data.map(c => ({
      value: c.emp_type_code,
      label: c.emp_type_desc
    }));
  
    setEmpType(formatted);
  };
  

  useEffect(() => {
    fetchContractorData();
    fetchBUData();
    fetchEntityData();
    fetchDeptData();
    fetchEmpType();
  }, []);

  useEffect(() => {
    //const present = attendanceData.filter(r => r.in_punch || r.out_punch || r.reg_in_punch || r.reg_out_punch).length;

    const present = attendanceData.reduce((sum, r) => {
      const mark = r.punch_mark?.toUpperCase();
      if (mark === 'P') return sum + 1;
      if (mark === 'HDP') return sum + 0.5;
      return sum; // PX or anything else - ignore
    }, 0);
    
    const presentHdp = attendanceData.reduce((sum, r) => {
      const mark = r.punch_mark?.toUpperCase();
      if (mark === 'HDP') return sum + 0.5;
      return sum; // PX or anything else - ignore
    }, 0);

    const presentPx = attendanceData.reduce((sum, r) => {
      const mark = r.punch_mark?.toUpperCase();
      if (mark === 'Px') return sum + 1;
      return sum; // PX or anything else - ignore
    }, 0);

    const approved = attendanceData.filter(r =>
      (r.in_punch || r.out_punch || r.reg_in_punch || r.reg_out_punch) &&
      r.atnd_approved?.toUpperCase() === 'Y'
    ).length;
    const totalOT = attendanceData.reduce((sum, r) => {
      const [h, m] = (r.ot_hours || "00:00").split(":");
      return sum + parseInt(h) + parseInt(m) / 60;
    }, 0).toFixed(2);

    setPresentCount(present);
    setPresentPxCount(presentPx);
    setPresentHdpCount(presentHdp);
    setApprovedCount(approved);
    setTotalOtHours(totalOT);
    setIsApprovedAlready(present > 0 && present === approved);
    setIsPartiallyApproved(approved > 0 && approved < present);
  }, [attendanceData]);
  
  const fetchAttendance = async () => {
    try {
    
      if (  !selectedDate ||
        !selectedEmpType?.value ||
        !selectedContractor?.value ||
        !selectedEntity?.value ||
        !selectedBU?.value ||
        !selectedDept?.value
      ) {
        alert("❗ Please select all filters properly.");
        return;
      }
  
      const payload = {
        contractor: selectedContractor?.value ? [selectedContractor.value] : [],
        bu: selectedBU?.value ? [selectedBU.value] : [],
        entity: selectedEntity?.value ? [selectedEntity.value] : [],
        department: selectedDept?.value ? [selectedDept.value] : [],
        from_date: selectedDate,
        to_date: selectedDate,
        //emp_type: selectedEmpType?.value?[selectedEmpType.value]: [],
        //emp_type: selectedEmpType ? [selectedEmpType] : [],  // directly use selectedEmpType
        emp_type: selectedEmpType?.value ? [selectedEmpType.value] : [],

        emp_id: emp_id,
        token: token,
      };
  
      // Fetch today's attendance
      const todayRes = await axios.post("/api/attendance/printAtndReg2ForApproval", payload);
      const todayData = todayRes.data || [];
      setAttendanceData(todayData);
      setSelectedForApproval([]);
  
      // Calculate yesterday's date
      const dateObj = new Date(selectedDate);
      dateObj.setDate(dateObj.getDate() - 1);
      const yesterdayStr = dateObj.toISOString().split('T')[0];
  
      // Fetch yesterday's attendance
      const yesterdayPayload = { ...payload, from_date: yesterdayStr, to_date: yesterdayStr };
      const yesterdayRes = await axios.post("/api/attendance/printAtndReg2ForApproval", yesterdayPayload);
      const yesterdayDataFetched = yesterdayRes.data || [];
      setYesterdayData(yesterdayDataFetched);
  
    } catch (err) {
      console.error("Error loading attendance", err);
    }
  };
  
  /*
  const handleSelectToggle = (record) => {
    const isAlreadySelected = selectedForApproval.some(sel => sel.employee_code === record.employee_code);
    if (isAlreadySelected) {
      setSelectedForApproval(prev => prev.filter(sel => sel.employee_code !== record.employee_code));
    } else {
      setSelectedForApproval(prev => [...prev, record]);
    }
  };
  */

  const handleSelectToggle = (record) => {
    const isAlreadySelected = selectedForApproval.some(sel => sel.employee_code === record.employee_code);
    if (isAlreadySelected) {
      setSelectedForApproval(prev => prev.filter(sel => sel.employee_code !== record.employee_code));
    } else {
      // 🔁 Always use the latest updated version from attendanceData
      const latestRecord = attendanceData.find(emp => emp.employee_code === record.employee_code);
      if (latestRecord) {
        setSelectedForApproval(prev => [...prev, latestRecord]);
      }
    }
  };
  
  const handleApproveSelected = async () => {
    if (!selectedDept) {
      alert("❗ Please select Department before approving.");
      return;
    }    
    if (selectedForApproval.length === 0) {
      alert("❗ Please select at least one employee to approve.");
      return;
    }
    try {
      const payload = {
        emp_id: emp_id,
        token: token,
        //records: selectedForApproval,
        /*
        records: selectedForApproval.map(emp => ({
          ...emp,
          dept_code: selectedDept?.value // 👈 overwrite from selectedDept
        })),      
        */
        records: attendanceData
        .filter(emp => selectedForApproval.some(sel => sel.employee_code === emp.employee_code))
        .map(emp => ({
          ...emp,
          dept_code: selectedDept?.value
        }))      
      };
      console.log("Submitting payload:", payload);
      const response = await fetch('/api/attendance/approveDailyAttendance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      if (!result.success) {
        console.error('Approval failed:', result);
        alert(result.message || "❌ Approval failed. Please try again.");
        return;
      }

      alert("✅ Selected Attendance successfully approved!");
      setAttendanceData([]);
      setSelectedForApproval([]);
      setPresentCount(0);
      setApprovedCount(0);
      setTotalOtHours("0.00");
      setIsApprovedAlready(false);
      setIsPartiallyApproved(false);
      scrollToTop();
    } catch (error) {
      console.error('Error approving attendance:', error);
    }
  };

  const handleUpdate = (employee_code, updatedRecord) => {
    setAttendanceData(prevData =>
      prevData.map(item =>
        item.employee_code === employee_code ? updatedRecord : item
      )
    );
  };
    

  if (!token) {
    return (
      <div>
        <p>You must be logged in to print daily attendance.</p>
        <button onClick={() => navigate("/")}>Go to Login</button>
      </div>
    );
  }

  return (
    <div className={styles.approveContainer}>
      <div ref={topRef}></div>
      <h2 className={styles.screenTitle}>Approve Daily Attendance</h2>

      <div className={styles.filters}>
        {/* Date and Filter Inputs */}

        <label>Date:</label>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => {
            setSelectedDate(e.target.value);
            setAttendanceData([]);
            setSelectedForApproval([]);
          }}
        />

        <div className={styles.filterControls}>
          <label>Show:</label>
          <select value={filterOption} onChange={(e) => setFilterOption(e.target.value)}>
            <option value="DEPT">Only Mapped to Dept</option> {/* 👈 Added */}
            <option value="UNAPPROVED">Only Unapproved</option>
            <option value="ALL">All Employees</option>
          </select>
        </div>
        <div className={styles.filterControls}>
          <label>Sort By:</label>
          <select value={sortOption} onChange={(e) => setSortOption(e.target.value)}>
            <option value="ALPHABETICAL">Alphabetical (A-Z)</option>
            <option value="DEPT_FIRST">Dept Employees First</option>
            <option value="YESTERDAY_FIRST">Yesterday Employees First</option>
          </select>
        </div>

        <label>Labour Type:</label>
        <Select
          options={empType}
          value={selectedEmpType} // 👈 directly object
          onChange={(selected) => {
            console.log("STage---1:", selected);
            setSelectedEmpType(selected); // 👈 store full object
            setAttendanceData([]);
            setSelectedForApproval([]);
          }}
          className={styles.select}
        />

        <label>Entity:</label>
        <Select
          options={entityList}
          value={selectedEntity}
          onChange={(selected) => {
            setSelectedEntity(selected);
            setAttendanceData([]);
            setSelectedForApproval([]);
          }}
          className={styles.select}
        />

        <label>Business Unit:</label>
        <Select
          options={buList}
          value={selectedBU}
          onChange={(selected) => {
            setSelectedBU(selected);
            setAttendanceData([]);
            setSelectedForApproval([]);
          }}
          className={styles.select}
        />

        <label>Department:</label>
        <Select
          options={deptList}
          value={selectedDept}
          onChange={(selected) => {
            setSelectedDepartment(selected);
            setAttendanceData([]);
            setSelectedForApproval([]);
          }}
          className={styles.select}
        />

        <label>Contractor:</label>
        <Select
          options={contractorList}
          value={selectedContractor}
          onChange={(selected) => {
            setSelectedContractor(selected);
            setAttendanceData([]);           // 👈 Clear
            setSelectedForApproval([]);       // 👈 Clear
          }}
          className={styles.select}
        />

        <button className={styles.fetchBtn} onClick={fetchAttendance}>Show Attendance</button>
      </div>

      {isApprovedAlready && (<p className={styles.approvedMsg}>✅ Attendance already approved.</p>)}
      {isPartiallyApproved && (<p className={styles.partialMsg}>⚠️ Partially approved attendance.</p>)}

      <div className={styles.attendanceList}>
        {(() => {
          const selectedDeptCode = selectedDept?.value;  // ✅ Safe here          
          const yesterdayApprovedEmployeeCodes = yesterdayData
          .filter(emp => 
            emp.atnd_approved?.toUpperCase() === 'Y' &&
            emp.dept_code === selectedDept?.value
          )
          .map(emp => emp.employee_code);
        
          const filteredData = attendanceData
            .filter(rec => {
              if (filterOption === 'ALL') return true;
              if (filterOption === 'UNAPPROVED') return rec.atnd_approved?.toUpperCase() !== 'Y';
              if (filterOption === 'DEPT') {
                if (!selectedDeptCode) return true;
                return rec.dept_code === selectedDeptCode;
              }
              return true;
            })
            .sort((a, b) => {
              if (sortOption === 'YESTERDAY_FIRST') {
                const aYesterday = yesterdayApprovedEmployeeCodes.includes(a.employee_code);
                const bYesterday = yesterdayApprovedEmployeeCodes.includes(b.employee_code);
                if (aYesterday && !bYesterday) return -1;
                if (!aYesterday && bYesterday) return 1;
              }
              if (sortOption === 'DEPT_FIRST') {
                const aInDept = selectedDept?.value && a.dept_code === selectedDept.value;
                const bInDept = selectedDept?.value && b.dept_code === selectedDept.value;
                if (aInDept && !bInDept) return -1;
                if (!aInDept && bInDept) return 1;
              }
              return (a.display_name || "").localeCompare(b.display_name || "");
            });

          if (filteredData.length === 0) {
            return <div className={styles.noRecords}>No records found.</div>;
          }

          return filteredData.map((rec, i) => (
            <AttendanceCard
              key={rec.employee_code}
              data={rec}
              originalData={rec}
              onChange={(updatedRec) => handleUpdate(rec.employee_code, updatedRec)} // ✅ pass employee_code
              isDisabled={rec.atnd_approved?.toUpperCase() === 'Y'}
              isSelected={selectedForApproval.some(sel => sel.employee_code === rec.employee_code)}
              isApprovedCard={rec.atnd_approved?.toUpperCase() === 'Y'}
              onSelectToggle={() => handleSelectToggle(rec)}
            />
          ));
        })()}
      </div>

      {/* 👇 Separate Summary Box */}
      {attendanceData.length > 0 && (() => {
        const selectedDeptCode = selectedDept?.value; // SINGLE VALUE
        const filteredData = attendanceData
          .filter(rec => {
            if (filterOption === 'ALL') return true;
            if (filterOption === 'UNAPPROVED') return rec.atnd_approved?.toUpperCase() !== 'Y';
            if (filterOption === 'DEPT') {
              if (!selectedDept || selectedDept.length === 0) return true;
              return rec.dept_code === selectedDeptCode;
            }
            return true;
          });

          const filteredDataPresent = filteredData
            .filter(rec => {
              if (rec.punch_mark?.toUpperCase() === 'P' ) return true;
            });
          const filteredDataHdp = filteredData
          .filter(rec => {
            if (rec.punch_mark?.toUpperCase() === 'HDP' ) return true;
          });
          const filteredDataPx = filteredData
          .filter(rec => {
            if (rec.punch_mark?.toUpperCase() === 'Px' ) return true;
          });
          const filteredDataAbs = filteredData
          .filter(rec => {
            if (rec.punch_mark?.toUpperCase() === 'A' ) return true;
          });
    

          return (
          <div className={styles.summaryBox}>
            <p><strong>Total Present:</strong> (P:{filteredDataPresent.length}, HDP:{filteredDataHdp.length}, A:{filteredDataAbs.length}, Px:{filteredDataPx.length} )  / {filteredData.length}</p>
            <p><strong>Total OT Hours:</strong> {totalOtHours}</p>
            <p><strong>Total Approved:</strong> {approvedCount}</p>
          </div>
        );
      })()}

      {attendanceData.length > 0 && (() => {
        const approvedSummary = {};

        // Already approved
        attendanceData.forEach(emp => {
          const deptName = emp.dept_name || "Unknown";
          if (!approvedSummary[deptName]) {
            approvedSummary[deptName] = { approved: 0, approvingNow: 0 };
          }
          if (emp.atnd_approved?.toUpperCase() === 'Y') {
            approvedSummary[deptName].approved += 1;
          }
        });

        // Approving Now
        if (selectedDept) {
          const selectedDeptName = selectedDept.label;
          if (!approvedSummary[selectedDeptName]) {
            approvedSummary[selectedDeptName] = { approved: 0, approvingNow: 0 };
          }
          approvedSummary[selectedDeptName].approvingNow = selectedForApproval.length;
        }

        return (
          <div className={styles.summaryBox}>
            <h3>Department Wise Approval Summary</h3>
            <table className={styles.summaryTable}>
              <thead>
                <tr>
                  <th>Department</th>
                  <th>Approved Already</th>
                  <th>Approving Now</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(approvedSummary).map(([dept, counts]) => (
                  <tr key={dept}>
                    <td>{dept}</td>
                    <td>{counts.approved}</td>
                    <td>{counts.approvingNow}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })()}


      {attendanceData.length > 0 && (
        <button className={styles.approveBtn} onClick={handleApproveSelected}>
          {isApprovedAlready ? "✔ Already Approved" : isPartiallyApproved ? "Approve Selected" : "Approve Selected"}
        </button>
      )}

      <button className={styles.cancelBtn} onClick={() => navigate("/dashboard")}>
        Cancel
      </button>

      <div ref={bottomRef}></div>
      <div ref={floatRef} className={styles.floatingButtons}>
        <button className={styles.goTop} onClick={scrollToTop}>⬆</button>
        <button className={styles.goBottom} onClick={scrollToBottom}>⬇</button>
      </div>
    </div>
  );
};

export default ApproveDailyAttendance;
